'use client'

import { Fragment } from 'react'
import { Button, Spacer, Image, Icon } from '@vinted/web-ui'
import { X12 } from '@vinted/monochrome-icons'

import { MediaUploadPhotoDto } from '@marketplace-web/item-upload/media-upload-data'

type Props = {
  images: Array<MediaUploadPhotoDto>
  onImageRemove: (image: MediaUploadPhotoDto) => () => void
}

const ImagePreview = ({ images, onImageRemove }: Props) => {
  const renderRemoveButton = (image: MediaUploadPhotoDto) => (
    <div className="image-preview__image-remove">
      <Button
        icon={<Icon name={X12} color="greyscale-level-3" />}
        size="small"
        inverse
        styling="filled"
        inline
        testId="image-preview-remove-button"
        onClick={onImageRemove(image)}
      />
    </div>
  )

  const renderImages = (): Array<JSX.Element> => {
    return images.map((image, index) => (
      <Fragment key={image.id}>
        <div className="image-preview__image">
          <Image src={image.full_size_url} styling="rounded" size="x2-large" />
          {renderRemoveButton(image)}
        </div>
        {images.length - 1 !== index && <Spacer orientation="vertical" />}
      </Fragment>
    ))
  }

  return <div className="image-preview">{renderImages()}</div>
}

export default ImagePreview
